import React from "react";
const WIDTH = 90;
const DEPTH = 40;
const HEIGHT = 30;

export default {
  name: "round-dining-table-for-6",
  prototype: "items",

  info: {
    tag: ["furnishings", "metal"],
    title: "round dining table for 6",
    description: "bathroom-sink",
    image: require("./round-dining-table-for-6.svg"),
    svgIcon: require("./round-dining-table-for-6.svg"),
  },
  properties: {
    scaleX: {
      label: "Width",
      type: "slider",
      min: 10,
      max: 500,
      defaultValue: 100,
    },
    scaleY: {
      label: "Depth",
      type: "slider",
      min: 10,
      max: 500,
      defaultValue: 100,
    },
  },

  render2D: function (element, layer, scene) {
    let angle = element.rotation + 90;

    return {
      element: (
        <g transform={`translate(-47, 55) scale(1, -1)`}>
          <defs>
            <style>{`.cls-1{fill:#fff;}`}</style>
          </defs>
          <g id={`${element.type}-${element.id}`} data-name="corner shower">
            <path
              d="M41.61,4.05a5.23,5.23,0,0,1-.94-.32A1.32,1.32,0,0,1,40,2.3,1.39,1.39,0,0,1,41,1a2,2,0,0,1,.6-.08q8.84,0,17.65,0a1.47,1.47,0,0,1,1.62,1.67A1.53,1.53,0,0,1,59.71,4c-.19,0-.39,0-.43.06.12,1.23.26,2.42.33,3.61,0,.42.2.53.56.61A40.73,40.73,0,0,1,74.86,15c2.27,1.69,4.36,3.62,6.57,5.47L84.85,19A1.66,1.66,0,0,1,85,17.11a1.6,1.6,0,0,1,2.61.39c.94,1.51,1.84,3.06,2.75,4.59l5.81,9.77.07.12c.6,1,.52,1.88-.2,2.39s-1.62.34-2.36-.56c0-.05-.1-.08,0,0-.92.64-1.82,1.32-2.77,1.91-.41.26-.52.47-.38.93a39.63,39.63,0,0,1,1.57,13.82,37.43,37.43,0,0,1-1.8,9.6c-.17.51,0,.7.38,1,.84.53,1.62,1.15,2.45,1.75a3.18,3.18,0,0,1,.53-.55,1.6,1.6,0,0,1,2,.13,1.54,1.54,0,0,1,.2,2c-.69,1.23-1.43,2.45-2.15,3.66L87.27,78.8a4.23,4.23,0,0,1-.55.78,1.52,1.52,0,0,1-1.88.27,1.5,1.5,0,0,1-.71-1.76,2.23,2.23,0,0,1,.17-.44l-3.61-1.48c-1,.86-2,1.84-3.06,2.75A42,42,0,0,1,59.19,88c-.57.13-.76.33-.77.93a24.81,24.81,0,0,1-.33,2.68,5.3,5.3,0,0,1,1.07.4,1.28,1.28,0,0,1,.62,1.41,1.42,1.42,0,0,1-1.07,1.21,3.16,3.16,0,0,1-.81.11q-8.58,0-17.17,0a2.91,2.91,0,0,1-1.29-.33,1.29,1.29,0,0,1-.61-1.54A1.43,1.43,0,0,1,40,91.75a3.53,3.53,0,0,1,.47-.07c-.1-1.13-.24-2.23-.29-3.33,0-.43-.28-.46-.56-.53a42.67,42.67,0,0,1-11.24-4.48,41.91,41.91,0,0,1-9.71-7.67.71.71,0,0,0-1-.16c-.89.44-1.83.78-2.72,1.14a4.19,4.19,0,0,1,.18,1.08,1.49,1.49,0,0,1-1.19,1.34,1.71,1.71,0,0,1-1.8-.86Q10.19,75,8.3,71.86q-2.43-4.1-4.85-8.2c-.6-1-.52-1.81.19-2.31s1.63-.39,2.42.55l0,0c1-.66,1.86-1.33,2.81-1.94.35-.23.44-.4.31-.81A39.64,39.64,0,0,1,7.62,46,38.3,38.3,0,0,1,9.53,35.7c.17-.5.13-.74-.36-1-.88-.53-1.7-1.19-2.55-1.8,0,0-.09.12-.19.23a1.64,1.64,0,0,1-2.1.39,1.51,1.51,0,0,1-.45-2.16c1.13-2,2.3-3.89,3.45-5.84q2.61-4.38,5.23-8.77c.68-1.15,1.84-1.41,2.67-.61.51.48.55,1,.24,1.95l3.76,1.59c1.26-1.1,2.54-2.31,3.91-3.41A41.9,41.9,0,0,1,40.68,8c.45-.1.57-.26.6-.71C41.34,6.21,41.49,5.14,41.61,4.05ZM91.55,47c-.21-1.69-.35-4.41-.91-7A39,39,0,0,0,76.1,16.71,41.58,41.58,0,0,0,43.34,8.14,40,40,0,0,0,20.93,19C10.42,29.16,6.35,41.54,9.07,55.86c2,10.49,7.75,18.74,16.44,24.9A41.3,41.3,0,0,0,43.91,88a42.31,42.31,0,0,0,13.66-.27A40.92,40.92,0,0,0,77,78.58C86.43,70.58,91.23,60.38,91.55,47ZM59,8a23.07,23.07,0,0,0-.3-2.81C58.43,4,58.33,4,57.14,4,52.55,4,48,4,43.35,4c-.55,0-.91.19-1,.68-.21,1-.34,2-.54,3.08A44.39,44.39,0,0,1,59,8ZM9.94,34.48A41,41,0,0,1,18.7,20.29,6.43,6.43,0,0,0,15.37,19a1,1,0,0,0-.69.37c-2.42,4-4.8,8-7.22,12a.89.89,0,0,0,.14,1.27C8.31,33.25,9.08,33.81,9.94,34.48Zm80.22,1.07c.92-.69,1.73-1.26,2.5-1.89a1,1,0,0,0,.14-1.38c-2.41-4-4.78-8-7.18-12a.81.81,0,0,0-.57-.35,5.57,5.57,0,0,0-3.24,1.22A41,41,0,0,1,90.16,35.55ZM17.66,74.9v-.28A41.18,41.18,0,0,1,9.51,60.33c-1,.61-2.1,1-2.65,2a.9.9,0,0,0,0,.78q3.6,6.13,7.27,12.23a.94.94,0,0,0,.75.39C15.8,75.53,16.73,75.2,17.66,74.9ZM90,61.52c-1.28,2.51-2.39,5-3.82,7.39S83,73.39,81.32,75.76c1,.33,1.94.68,2.93,1,.39.13.66-.08.88-.44q3.57-6,7.18-12.07a.77.77,0,0,0,0-1A5.73,5.73,0,0,0,90,61.52ZM57.71,88.36a46.33,46.33,0,0,1-16.85-.22,5,5,0,0,0,.48,3.14,1,1,0,0,0,.69.4q7.28,0,14.56,0a.92.92,0,0,0,.62-.37A4.28,4.28,0,0,0,57.71,88.36Zm-8.42,5.72h8.44a3.37,3.37,0,0,0,.55,0,.85.85,0,0,0,.82-.86.78.78,0,0,0-.77-.81,6.3,6.3,0,0,0-.75-.05H40.92a1.49,1.49,0,0,0-.74.08c-.28.17-.67.48-.66.72a1.46,1.46,0,0,0,.6.86c.17.12.49.07.74.07Zm-44-60.89a6.27,6.27,0,0,0,.88-.94c2.53-4.21,5-8.43,7.54-12.65.41-.68.82-1.37,1.2-2.07a.74.74,0,0,0-.31-1.06.78.78,0,0,0-1.1.16,4.48,4.48,0,0,0-.47.67L7.76,26.14c-1.07,1.8-2.17,3.6-3.21,5.42a1.54,1.54,0,0,0-.08,1.06C4.53,32.83,4.9,33,5.26,33.19ZM4.84,61.71c-.81,0-1.24.55-1,1.12a3,3,0,0,0,.32.61l6.75,11.35,1.83,3.06a.88.88,0,0,0,1.26.44c.5-.25.57-.73.24-1.35,0-.08-.09-.16-.14-.24L9.14,68.47c-1.19-2-2.36-4-3.57-6A3.83,3.83,0,0,0,4.84,61.71ZM85.69,79.54a5.28,5.28,0,0,0,.82-.82c2.07-3.45,4.12-6.9,6.18-10.36Q94,66.19,95.26,64c.23-.39.28-.85-.14-1.1a1.35,1.35,0,0,0-1-.08c-.24.07-.41.4-.56.65Q90.71,68.22,87.88,73c-1,1.63-2,3.25-2.89,4.9A1.6,1.6,0,0,0,84.91,79C85,79.18,85.34,79.3,85.69,79.54ZM96.11,33.29c-.18-.39-.28-.64-.41-.87L89.06,21.24c-.68-1.14-1.36-2.28-2-3.4a.88.88,0,0,0-1.26-.43.84.84,0,0,0-.25,1.25q.14.27.3.54l6.71,11.29c.6,1,1.16,2,1.82,3a1.34,1.34,0,0,0,1,.46C95.6,33.91,95.85,33.52,96.11,33.29Zm-45.72-30h8.38a1.79,1.79,0,0,0,.81-.06c.27-.17.63-.51.61-.76s-.36-.61-.63-.82-.44-.05-.67-.05H42a5,5,0,0,0-.55,0,.82.82,0,0,0-.82.84.79.79,0,0,0,.84.82c.22,0,.45,0,.68,0Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M91.55,47C91.23,60.38,86.43,70.58,77,78.58a40.92,40.92,0,0,1-19.47,9.1A42.31,42.31,0,0,1,43.91,88a41.3,41.3,0,0,1-18.4-7.19C16.82,74.6,11.06,66.35,9.07,55.86,6.35,41.54,10.42,29.16,20.93,19A40,40,0,0,1,43.34,8.14,41.58,41.58,0,0,1,76.1,16.71,39,39,0,0,1,90.64,40C91.2,42.63,91.34,45.35,91.55,47ZM83.71,64.36A5.7,5.7,0,1,0,78,69.78,5.59,5.59,0,0,0,83.71,64.36ZM55,79.7a5.7,5.7,0,1,0-5.7,5.54A5.63,5.63,0,0,0,55,79.7ZM84.27,32.32a5.59,5.59,0,0,0-5.7-5.45,5.53,5.53,0,1,0,0,11.06A5.55,5.55,0,0,0,84.27,32.32ZM56.12,16.05a5.6,5.6,0,0,0-5.63-5.6,5.66,5.66,0,0,0-5.76,5.49,5.7,5.7,0,0,0,11.39.11ZM26.84,63.16a5.61,5.61,0,0,0-5.63-5.38,5.52,5.52,0,1,0-.13,11A5.58,5.58,0,0,0,26.84,63.16ZM27.4,31.6a5.57,5.57,0,0,0-5.69-5.69A5.53,5.53,0,1,0,21.61,37,5.6,5.6,0,0,0,27.4,31.6Zm13.43-7.31A2.14,2.14,0,0,0,43,22.18a2.2,2.2,0,0,0-2.19-2.11,2.18,2.18,0,0,0-2.16,2.13A2.13,2.13,0,0,0,40.83,24.29ZM79.45,53.06a2.16,2.16,0,1,0-2.13,2.13A2.12,2.12,0,0,0,79.45,53.06Zm-57-12.55a2.11,2.11,0,1,0,0,4.22,2.21,2.21,0,0,0,2.16-2.07A2.19,2.19,0,0,0,22.47,40.51Zm9,25.67a2.13,2.13,0,0,0-2.14,2.13,2.18,2.18,0,0,0,4.35-.07A2.14,2.14,0,0,0,31.45,66.18ZM70.39,27.47a2.15,2.15,0,1,0-2.19,2.06A2.12,2.12,0,0,0,70.39,27.47Zm-9.34,46a2.14,2.14,0,0,0-4.28,0,2.1,2.1,0,0,0,2.13,2.12A2.14,2.14,0,0,0,61.05,73.51ZM42.15,84c.46-.55.4-7.9,0-8.23ZM43.4,20c.42-.5.41-7.91,0-8.38ZM28.14,67.27,28,67l-7.34,4.12.17.29C23.25,70,25.74,68.73,28.14,67.27Zm43,.79-.18.3,7.34,4.1.17-.29ZM14.47,35l-.16.29,7.33,4.11.17-.29Zm71.58,1.33-.1-.22c-.08,0-.17,0-.23,0Q82.26,38,78.79,40c-.09.05-.13.21-.19.31l.12.11Zm-64.61-13-.16.28c2.43,1.41,4.89,2.75,7.33,4.13l.17-.3ZM13.69,59.44l.16.27,7.33-4.11L21,55.31C18.58,56.69,16.11,58,13.69,59.44Zm65.4-34.88-.17-.29-7.36,4.12.17.29Zm6.17,36.19c-.28-.7-6.89-4.33-7.4-4.15ZM57.14,83.28c.32-.36.49-4.85.3-6.36,0-.11-.13-.21-.19-.31l-.11.06ZM77.82,24.11l-.11-.18c-.78.14-5.66,3-5.88,3.53ZM28.09,68.51c-.72-.1-5.86,2.78-6.16,3.46ZM14.54,36.15c.32.74,5.57,3.62,6,3.37ZM85.05,59.47l.16-.3-5.86-3.28-.17.3ZM57.54,11.53c-.37.78-.31,8,0,8.36ZM56.31,75.84h-.16V84h.16ZM42.56,12.52H42.4V19h.16Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M59,8A44.39,44.39,0,0,0,41.8,7.75c.2-1.13.33-2.11.54-3.08.1-.49.46-.68,1-.68,4.6,0,9.2,0,13.79,0,1.19,0,1.29,0,1.55,1.16A23.07,23.07,0,0,1,59,8Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M9.94,34.48c-.86-.67-1.63-1.23-2.34-1.84a.89.89,0,0,1-.14-1.27c2.42-4,4.8-8,7.22-12a1,1,0,0,1,.69-.37,6.43,6.43,0,0,1,3.33,1.32A41,41,0,0,0,9.94,34.48Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M90.16,35.55a41,41,0,0,0-8.35-14.4,5.57,5.57,0,0,1,3.24-1.22.81.81,0,0,1,.57.35c2.4,4,4.77,8,7.18,12a1,1,0,0,1-.14,1.38C91.89,34.29,91.08,34.86,90.16,35.55Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M17.66,74.9c-.93.3-1.86.63-2.82.87a.94.94,0,0,1-.75-.39q-3.66-6.09-7.27-12.23a.9.9,0,0,1,0-.78c.55-1,1.61-1.43,2.65-2a41.18,41.18,0,0,0,8.16,14.29Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M90,61.52a5.73,5.73,0,0,1,2.24,1.72.77.77,0,0,1,0,1q-3.6,6-7.18,12.07c-.22.36-.49.57-.88.44-1-.3-2-.65-2.93-1,1.71-2.37,3.46-4.52,4.89-6.85S88.75,64,90,61.52Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M57.71,88.36a4.28,4.28,0,0,1-.5,3,.92.92,0,0,1-.62.37q-7.29,0-14.56,0a1,1,0,0,1-.69-.4,5,5,0,0,1-.48-3.14A46.33,46.33,0,0,0,57.71,88.36Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M49.29,94.08H40.86c-.25,0-.57,0-.74-.07a1.46,1.46,0,0,1-.6-.86c0-.24.38-.55.66-.72a1.49,1.49,0,0,1,.74-.08H57.58a6.3,6.3,0,0,1,.75.05.78.78,0,0,1,.77.81.85.85,0,0,1-.82.86,3.37,3.37,0,0,1-.55,0Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M5.26,33.19c-.36-.24-.73-.36-.79-.57a1.54,1.54,0,0,1,.08-1.06c1-1.82,2.14-3.62,3.21-5.42L13,17.3a4.48,4.48,0,0,1,.47-.67.78.78,0,0,1,1.1-.16.74.74,0,0,1,.31,1.06c-.38.7-.79,1.39-1.2,2.07-2.51,4.22-5,8.44-7.54,12.65A6.27,6.27,0,0,1,5.26,33.19Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M4.84,61.71a3.83,3.83,0,0,1,.73.76c1.21,2,2.38,4,3.57,6l4.91,8.23c0,.08.1.16.14.24.33.62.26,1.1-.24,1.35a.88.88,0,0,1-1.26-.44l-1.83-3.06L4.11,63.44a3,3,0,0,1-.32-.61C3.6,62.26,4,61.68,4.84,61.71Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M85.69,79.54c-.35-.24-.73-.36-.78-.57A1.6,1.6,0,0,1,85,77.89c.93-1.65,1.92-3.27,2.89-4.9q2.84-4.76,5.69-9.52c.15-.25.32-.58.56-.65a1.35,1.35,0,0,1,1,.08c.42.25.37.71.14,1.1Q94,66.19,92.69,68.36c-2.06,3.46-4.11,6.91-6.18,10.36A5.28,5.28,0,0,1,85.69,79.54Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M96.11,33.29c-.26.23-.51.62-.77.63a1.34,1.34,0,0,1-1-.46c-.66-1-1.22-2-1.82-3L85.8,19.2q-.17-.27-.3-.54a.84.84,0,0,1,.25-1.25.88.88,0,0,1,1.26.43c.69,1.12,1.37,2.26,2,3.4L95.7,32.42C95.83,32.65,95.93,32.9,96.11,33.29Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M50.39,3.32H42.15c-.23,0-.46,0-.68,0a.79.79,0,0,1-.84-.82.82.82,0,0,1,.82-.84,5,5,0,0,1,.55,0H58.89c.23,0,.53-.07.67.05s.61.53.63.82-.34.59-.61.76a1.79,1.79,0,0,1-.81.06Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M83.71,64.36A5.71,5.71,0,1,1,78,58.73,5.59,5.59,0,0,1,83.71,64.36Zm-11-.14A5.25,5.25,0,0,0,78,69.46a5.2,5.2,0,1,0,0-10.4A5.26,5.26,0,0,0,72.68,64.22Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M55,79.7a5.7,5.7,0,1,1-5.7-5.54A5.61,5.61,0,0,1,55,79.7Zm-5.71,5.18A5.18,5.18,0,1,0,44,79.69,5.24,5.24,0,0,0,49.28,84.88Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M84.27,32.32a5.55,5.55,0,0,1-5.67,5.61,5.53,5.53,0,1,1,0-11.06A5.59,5.59,0,0,1,84.27,32.32Zm-11,.15a5.35,5.35,0,1,0,5.28-5.26A5.26,5.26,0,0,0,73.25,32.47Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M56.12,16.05a5.7,5.7,0,0,1-11.39-.11,5.66,5.66,0,0,1,5.76-5.49A5.6,5.6,0,0,1,56.12,16.05Zm-5.68,5.13A5.31,5.31,0,0,0,55.81,16a5.32,5.32,0,0,0-5.39-5.17,5.19,5.19,0,1,0,0,10.37Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M26.84,63.16a5.7,5.7,0,0,1-11.4.28,5.58,5.58,0,0,1,5.77-5.66A5.61,5.61,0,0,1,26.84,63.16Zm-11,.2a5.27,5.27,0,0,0,5.33,5.15A5.34,5.34,0,0,0,26.5,63.3a5.35,5.35,0,0,0-10.69.06Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M27.4,31.6A5.71,5.71,0,0,1,16,31.32a5.66,5.66,0,0,1,5.71-5.41A5.57,5.57,0,0,1,27.4,31.6Zm-5.63-5.36a5.2,5.2,0,1,0,0,10.4,5.2,5.2,0,1,0,0-10.4Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M40.83,24.29a2.13,2.13,0,0,1-2.18-2.09,2.18,2.18,0,0,1,2.16-2.13A2.2,2.2,0,0,1,43,22.18,2.14,2.14,0,0,1,40.83,24.29Zm0-.36A1.75,1.75,0,1,0,39,22.16,1.75,1.75,0,0,0,40.79,23.93Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M79.45,53.06A2.16,2.16,0,1,1,77.27,51,2.13,2.13,0,0,1,79.45,53.06Zm-2.16,1.78a1.76,1.76,0,1,0-.07-3.52,1.78,1.78,0,0,0-1.75,1.75A1.82,1.82,0,0,0,77.29,54.84Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M22.47,40.51a2.19,2.19,0,0,1,2.15,2.15,2.21,2.21,0,0,1-2.16,2.07,2.11,2.11,0,1,1,0-4.22Zm-1.84,2.07a1.76,1.76,0,0,0,1.76,1.8,1.78,1.78,0,0,0,1.85-1.7,1.8,1.8,0,0,0-1.79-1.84A1.78,1.78,0,0,0,20.63,42.58Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M31.45,66.18a2.14,2.14,0,0,1,2.21,2.06,2.18,2.18,0,0,1-4.35.07A2.13,2.13,0,0,1,31.45,66.18Zm1.84,2.12A1.81,1.81,0,1,0,31.48,70,1.78,1.78,0,0,0,33.29,68.3Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M70.39,27.47a2.15,2.15,0,1,1-2.09-2.16A2.12,2.12,0,0,1,70.39,27.47Zm-2.13,1.71a1.76,1.76,0,1,0,0-3.52,1.76,1.76,0,1,0,0,3.52Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M61.05,73.51a2.14,2.14,0,0,1-2.15,2.11,2.11,2.11,0,1,1,0-4.21A2.07,2.07,0,0,1,61.05,73.51Zm-2.13,1.75a1.8,1.8,0,0,0,1.82-1.82,1.84,1.84,0,1,0-1.82,1.82Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M42.15,84V75.79C42.55,76.12,42.61,83.47,42.15,84Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M43.4,20V11.6C43.81,12.07,43.82,19.48,43.4,20Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M28.14,67.27c-2.4,1.46-4.89,2.77-7.33,4.16l-.17-.29L28,67Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M71.13,68.06l7.33,4.11-.17.29L71,68.36Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M14.47,35l7.34,4.11-.17.29-7.33-4.11Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M86.05,36.28l-7.33,4.11-.12-.11c.06-.1.1-.26.19-.31q3.46-2,6.93-3.88c.06,0,.15,0,.23,0Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M21.44,23.23l7.34,4.11-.17.3c-2.44-1.38-4.9-2.72-7.33-4.13Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M13.69,59.44C16.11,58,18.58,56.69,21,55.31l.17.29-7.33,4.11Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M79.09,24.56l-7.36,4.12-.17-.29,7.36-4.12Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M85.26,60.75l-7.4-4.15C78.37,56.42,85,60.05,85.26,60.75Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M57.14,83.28V76.67l.11-.06c.06.1.17.2.19.31C57.63,78.43,57.46,82.92,57.14,83.28Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M77.82,24.11l-6,3.35c.22-.57,5.1-3.39,5.88-3.53Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M28.09,68.51,21.93,72C22.23,71.29,27.37,68.41,28.09,68.51Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M14.54,36.15l6,3.37C20.11,39.77,14.86,36.89,14.54,36.15Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M85.05,59.47l-5.87-3.28.17-.3,5.86,3.28Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M57.54,11.53v8.36C57.23,19.53,57.17,12.31,57.54,11.53Z"
              transform="translate(-3.05 -0.95)"
            />
            <ellipse cx="53.18" cy="78.97" rx="0.11" ry="5.78" />
            <path
              d="M42.56,12.52v6.53H42.4V12.52Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M72.68,64.22a5.35,5.35,0,0,1,10.69-.06,5.32,5.32,0,0,1-5.4,5.3A5.25,5.25,0,0,1,72.68,64.22ZM82,66.28c0-.19,0-.23,0-.28-.49-1.75-1-3.51-1.45-5.27-.1-.38-.31-.43-.66-.33-1.81.47-3.62.92-5.42,1.41a.65.65,0,0,0-.34.55c.46,1.79.94,3.57,1.46,5.34A.61.61,0,0,0,76,68c1.86-.45,3.72-.93,5.56-1.43C81.76,66.56,81.88,66.36,82,66.28Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M49.28,84.88a5.18,5.18,0,1,1,5.36-5.16A5.24,5.24,0,0,1,49.28,84.88Zm4.65-5.23a2.5,2.5,0,0,0-.25-.34l-3.93-3.83c-.31-.31-.54-.29-.85,0C47.61,76.77,46.31,78,45,79.27c-.31.29-.28.5,0,.78,1.27,1.22,2.53,2.44,3.77,3.69.41.4.68.37,1.07,0,1.24-1.25,2.51-2.46,3.77-3.69A2.37,2.37,0,0,0,53.93,79.65Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M73.25,32.47a5.35,5.35,0,1,1,5.33,5.13A5.24,5.24,0,0,1,73.25,32.47Zm9.29-2.13A1.76,1.76,0,0,0,82,30l-5.3-1.39c-.43-.11-.62,0-.73.45-.46,1.72-.92,3.44-1.42,5.14-.13.46,0,.57.41.66,1.79.46,3.58.92,5.37,1.4a.45.45,0,0,0,.65-.38c.18-.66.37-1.31.56-2C81.89,32.76,82.19,31.64,82.54,30.34Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M50.44,21.18a5.19,5.19,0,1,1,0-10.37A5.32,5.32,0,0,1,55.81,16,5.31,5.31,0,0,1,50.44,21.18ZM45.8,16l.23-.1c1.35,1.45,2.69,2.92,4.07,4.35a.7.7,0,0,0,.67,0c1.34-1.27,2.66-2.58,4-3.85.27-.27.24-.44,0-.68l-3.92-3.83c-.33-.32-.59-.29-.92,0-1.24,1.24-2.52,2.46-3.77,3.69C46,15.75,45.92,15.89,45.8,16Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M15.81,63.36A5.35,5.35,0,0,1,26.5,63.3a5.34,5.34,0,0,1-5.36,5.21A5.27,5.27,0,0,1,15.81,63.36Zm7.47,3.82c.09-.08.33-.18.37-.34q.78-2.69,1.49-5.4a.64.64,0,0,0-.32-.53c-1.82-.5-3.66-1-5.5-1.45-.35-.09-.53,0-.63.42-.46,1.74-1,3.47-1.42,5.21a.68.68,0,0,0,.3.59C19.42,66.19,21.29,66.67,23.28,67.18Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M21.77,26.24a5.2,5.2,0,1,1,0,10.4,5.2,5.2,0,1,1,0-10.4Zm-4,3.16c0,.16,0,.21,0,.25.5,1.8,1,3.6,1.52,5.39a.67.67,0,0,0,.6.24c1.8-.43,3.58-.91,5.38-1.36.38-.1.51-.27.39-.69-.49-1.72-1-3.46-1.46-5.19-.05-.17-.39-.41-.54-.37q-2.79.67-5.57,1.43C18,29.14,17.83,29.32,17.74,29.4Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M40.79,23.93a1.75,1.75,0,1,1,1.84-1.71A1.74,1.74,0,0,1,40.79,23.93Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M77.29,54.84a1.82,1.82,0,0,1-1.82-1.77,1.78,1.78,0,0,1,1.75-1.75,1.76,1.76,0,1,1,.07,3.52Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M20.63,42.58a1.78,1.78,0,0,1,1.82-1.74,1.8,1.8,0,0,1,1.79,1.84,1.78,1.78,0,0,1-1.85,1.7A1.76,1.76,0,0,1,20.63,42.58Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M33.29,68.3a1.81,1.81,0,1,1-1.84-1.79A1.78,1.78,0,0,1,33.29,68.3Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M68.26,29.18a1.76,1.76,0,1,1,0-3.52,1.76,1.76,0,1,1,0,3.52Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M58.92,75.26a1.82,1.82,0,0,1-1.85-1.72,1.84,1.84,0,0,1,3.67-.1A1.8,1.8,0,0,1,58.92,75.26Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M82,66.28c-.09.08-.21.28-.38.32-1.84.5-3.7,1-5.56,1.43a.61.61,0,0,1-.51-.33c-.52-1.77-1-3.55-1.46-5.34a.65.65,0,0,1,.34-.55c1.8-.49,3.61-.94,5.42-1.41.35-.1.56,0,.66.33.47,1.76,1,3.52,1.45,5.27C81.94,66.05,81.94,66.09,82,66.28Zm-7.63-4.11,1.55,5.58,5.74-1.5-1.54-5.58Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M53.93,79.65a2.37,2.37,0,0,1-.29.38c-1.26,1.23-2.53,2.44-3.77,3.69-.39.39-.66.42-1.07,0-1.24-1.25-2.5-2.47-3.77-3.69-.3-.28-.33-.49,0-.78,1.3-1.25,2.6-2.5,3.89-3.77.31-.31.54-.33.85,0l3.93,3.83A2.5,2.5,0,0,1,53.93,79.65ZM49.3,75.51l-3.79,4.12,3.81,4.18,3.89-4.15Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M82.54,30.34c-.35,1.3-.65,2.42-1,3.54-.19.66-.38,1.31-.56,2a.45.45,0,0,1-.65.38c-1.79-.48-3.58-.94-5.37-1.4-.36-.09-.54-.2-.41-.66.5-1.7,1-3.42,1.42-5.14.11-.42.3-.56.73-.45L82,30A1.76,1.76,0,0,1,82.54,30.34Zm-6.11-1.48-1.55,5.59,5.76,1.48c.53-1.91,1-3.72,1.53-5.57Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M45.8,16c.12-.14.22-.28.35-.41,1.25-1.23,2.53-2.45,3.77-3.69.33-.34.59-.37.92,0l3.92,3.83c.25.24.28.41,0,.68-1.34,1.27-2.66,2.58-4,3.85a.7.7,0,0,1-.67,0c-1.38-1.43-2.72-2.9-4.07-4.35Zm4.57,4.14,3.88-4.1-3.81-4.22-4,4.24Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M23.28,67.18c-2-.51-3.86-1-5.71-1.5a.68.68,0,0,1-.3-.59c.45-1.74,1-3.47,1.42-5.21.1-.38.28-.51.63-.42,1.84.48,3.68.95,5.5,1.45a.64.64,0,0,1,.32.53q-.7,2.72-1.49,5.4C23.61,67,23.37,67.1,23.28,67.18ZM19.1,59.76c-.5,1.8-1,3.48-1.45,5.16-.1.37.09.48.4.56l3.51.9,1.75.45,1.53-5.58Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              d="M17.74,29.4c.09-.08.21-.26.36-.3q2.77-.75,5.57-1.43c.15,0,.49.2.54.37.51,1.73,1,3.47,1.46,5.19.12.42,0,.59-.39.69-1.8.45-3.58.93-5.38,1.36a.67.67,0,0,1-.6-.24c-.53-1.79-1-3.59-1.52-5.39C17.77,29.61,17.77,29.56,17.74,29.4Zm.35,0L19.63,35l5.75-1.49L23.84,28Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M74.34,62.17l5.75-1.5,1.54,5.58-5.74,1.5Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M49.3,75.51l3.91,4.15-3.89,4.15-3.81-4.18Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M76.43,28.86l5.74,1.5c-.51,1.85-1,3.66-1.53,5.57l-5.76-1.48Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M50.37,20.17l-3.9-4.08,4-4.24,3.81,4.22Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M19.1,59.76l5.74,1.49-1.53,5.58-1.75-.45-3.51-.9c-.31-.08-.5-.19-.4-.56C18.13,63.24,18.6,61.56,19.1,59.76Z"
              transform="translate(-3.05 -0.95)"
            />
            <path
              class="cls-1"
              d="M18.09,29.44,23.84,28l1.54,5.58L19.63,35Z"
              transform="translate(-3.05 -0.95)"
            />
          </g>
        </g>
      ),
      transform: {
        width: -WIDTH / 2,
        depth: -DEPTH / 2,
      },
    };
  },

  render3D: function (element, layer, scene) {},
};
